/*
 * Copyright (c) 2005, The haXe Project Contributors
 * All rights reserved.
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 *   - Redistributions of source code must retain the above copyright
 *     notice, this list of conditions and the following disclaimer.
 *   - Redistributions in binary form must reproduce the above copyright
 *     notice, this list of conditions and the following disclaimer in the
 *     documentation and/or other materials provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY THE HAXE PROJECT CONTRIBUTORS "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE HAXE PROJECT CONTRIBUTORS BE LIABLE FOR
 * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT
 * LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY
 * OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH
 * DAMAGE.
 */
/**
 * package: haxe
 * class: Timer
 * root Object
 * @constructor
 */
haxe.Timer = function(time_ms) {
	/** @type {haxe.Timer} */ 
	var me = this;
	this.id = window.setInterval(function() {
		me.run();
	},time_ms);
};
$hxClasses['haxe.Timer'] = haxe.Timer;
/** @private @type {Array} */
haxe.Timer.__name__ = ["haxe","Timer"];

/**
 * delay
 * This will delay the call to [f] for the given time. [f] will only be called once.
 * *
 * --------------------- *
 *
 * $type TFun([{ name => f, t => TFun([],TEnum(Void,[])), opt => false },{ name => time_ms, t => TInst(Int,[]), opt => false }],TInst(haxe.Timer,[]))
 * public static function delay( f : Void -> Void, time_ms : Int )
 * @public
 * @static
 * @param {TFun([],TEnum(Void,[]))}  f 
 * @param {number}  time_ms 
 * @return {haxe.Timer}
 */
haxe.Timer.delay = function(f,time_ms) {
	/** @type {haxe.Timer} */ 
	var t = new haxe.Timer(time_ms);
	t.run = function() {
		t.stop();
		f();
	};
	return t;
};


/**
 * measure
 * Measure the time it takes to execute the function [f] and trace it. Returns the value returned by [f].
 * *
 * --------------------- *
 *
 * $type TFun([{ name => f, t => TFun([],TInst(measure.T,[])), opt => false },{ name => pos, t => TType(haxe.PosInfos,[]), opt => true }],TInst(measure.T,[]))
 * @public
 * @static
 * @param {TFun([],TInst(measure.T,[]))}  f 
 * @param {haxe.PosInfos}  pos 
 * @return {measure.T}
 */
haxe.Timer.measure = function(f,pos) {
	/** @type {number} */ 
	var t0 = haxe.Timer.stamp();
	/** @type {measure.T} */ 
	var r = f();
	haxe.Log.trace(haxe.Timer.stamp() - t0 + "s",pos);
	return r;
};


/**
 * stamp
 * Returns the most precise timestamp, in seconds. The value itself might differ depending on platforms, only differences between two values make sense.
 * *
 * --------------------- *
 *
 * $type TFun([],TInst(Float,[]))
 * @public
 * @static
 * @return {number}
 */
haxe.Timer.stamp = function() {
	return new Date().getTime() / 1000;
};


/**
 * run
 * This is the [run()] method that is called when the Timer executes. It can be either overriden in subclasses or directly rebinded with another function-value.
 * *
 * --------------------- *
 *
 * $type TFun([],TEnum(Void,[]))
 * function run()
 * @public
 * @this haxe.Timer
 * @return {void}
 */
haxe.Timer.prototype.run = function() {
};


/**
 * stop
 * Stop the timer definitely.
 * *
 * --------------------- *
 *
 * $type TFun([],TEnum(Void,[]))
 * public function stop()
 * @public
 * @this haxe.Timer
 * @return {void}
 */
haxe.Timer.prototype.stop = function() {
	if(this.id == null) return;
	window.clearInterval(this.id);
	this.id = null;
};

/** @private @type {Null} */
haxe.Timer.prototype.id = null;
/** @type {haxe.Timer} */
haxe.Timer.prototype.__class__ = haxe.Timer;
